const TOKEN_URL = 'http://royhome.net';
const OWNER = 'owner';
const ROLES = {
  FRIEND: 'friend',
  ENGINEER: 'engineer',
  FAMILY: 'family',
  COMPANY: 'company',
  ADMIN: 'admin',
};

export { TOKEN_URL, OWNER, ROLES };
